import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDashboardEditor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 6,
			height: 6,
			rx: 1.25,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 3,
			width: 6,
			height: 6,
			rx: 1.25,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 11,
			width: 6,
			height: 6,
			rx: 1.25,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 11,
			width: 6,
			height: 6,
			rx: 1.25,
			fill: "currentColor"
		})
	]
});
export default SvgDashboardEditor;
